import React, { useState } from 'react';
import classNames from 'classnames';
import { useFormContext } from 'react-hook-form';
import { useInput } from '../form/hooks/useInput';
import { RadioGroupContextProvider } from './context';
import BaseRadio from './BaseRadio';
const RadioGroup = (props) => {
    const { className, children, options, value, onChange } = props;
    const formInstance = useFormContext();
    let groupProps = {};
    if (!formInstance) {
        const [val, setVal] = useState(value);
        groupProps = {
            onChange: (e) => {
                onChange?.(e.target.value);
                setVal(e.target.value);
            },
            value: val,
        };
    }
    else {
        const { field } = useInput(props);
        groupProps = field;
    }
    let childrenToRender = children;
    if (options && options.length > 0) {
        childrenToRender = options.map((option) => {
            if (typeof option === 'string' || typeof option === 'number') {
                return (React.createElement(BaseRadio, { key: option.toString(), value: option }, option));
            }
            return (React.createElement(BaseRadio, { key: `radio-group-value-options-${option.value}`, value: option.value }, option.label));
        });
    }
    const classString = classNames('radio-group', {
        [className]: className,
    });
    return (React.createElement("div", { className: classString },
        React.createElement(RadioGroupContextProvider, { value: groupProps }, childrenToRender)));
};
export default RadioGroup;
//# sourceMappingURL=Group.js.map